import { createFileRoute } from "@tanstack/react-router";
import Pricing from "@/pages/Pricing";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/th/pricing")({
  head: () => pageHead("/pricing", "th"),
  component: Pricing,
});
